import { Injectable } from '@angular/core';

@Injectable()
export class CsvExportService {
  constructor() {}

  private processRow = function(row) {
    let finalVal = '';
    for (let j = 0; j < row.length; j++) {
      let innerValue = row[j] === null ? '' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      }
      let result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0) {
        result = '"' + result + '"';
      }
      if (j > 0) {
        finalVal += ',\n';
      }
      finalVal += result;
    }
    return finalVal + '\n';
  };

  save(rows, filename) {
    let csvFile = '';

    for (const row of rows) {
      csvFile +=
        row
          .map(x => {
            return '"' + x.toString().replace(/"/g, "'") + '"';
          })
          .join(',') + '\n';
    }

    this.download(csvFile, filename + '.csv');
  }

  exportToCsv(filename, rows) {
    let csvFile = '';
    for (let i = 0; i < rows.length; i++) {
      csvFile += this.processRow(rows[i]);
    }

    this.download(csvFile, filename);
  }

  private download(csvText, filename) {
    const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/csv-export.service.ts